__turbopack_context__.v({
  "hero": "fxzPfG_hero",
  "heroContent": "fxzPfG_heroContent",
  "title": "fxzPfG_title",
});
